import { SET_CURRENT_GXT } from './gxt.type'

export const setCurrentGtx = (data) => async (dispatch) => {
    dispatch({
        type: SET_CURRENT_GXT,
        payload: data,
    })
}
